import { Col, Row } from 'react-bootstrap';
import React from 'react';
import moment from 'moment';
import logoImg from '../../assets/images/logo-light.png';

const ComponentPrint = ({ data }) => {
    let { dia, inicio, fin, nombre } = data;

    let periodo = moment(inicio).format('LL') + ' al ' + moment(fin).format('LL');

    return (
        <div className="mb-3">
            <div className="clearfix ">
                <div className="float-start mb-3">
                    <img src={logoImg} alt="logo" height="25" crossOrigin="anonymous" />
                </div>
                <div className="float-end">
                    <h4 className="m-0 d-print-none">Nomina</h4>
                </div>
            </div>

            <Row>
                <Col>
                    <div className="mt-3 text-center">
                        <p className="font-13">
                            <strong className="text-uppercase">DESGLOSE DE SUELDO DEL PERIODO: {periodo}</strong>
                        </p>
                    </div>
                </Col>
            </Row>

            <Row className="mt-1">
                <Col sm={4}>
                    <h5>Empleado: {nombre}</h5>
                </Col>
                <Col sm={4} lg={{ span: 4, offset: 4 }}>
                    <h5>Sueldo por dia: ${dia}</h5>
                </Col>
            </Row>

            <Row className=" m-3" style={{ borderBottom: '2px dotted #000' }}>
                <Col>
                    <div className="table table-bordered border-primary table-responsive fs-6">
                        <table className="table mt-4  table-bordered border-secondary ">
                            <thead className="table-secondary">
                                <tr>
                                    <th>Sueldo Efectivo</th>
                                    <th>Sueldo Transferencia</th>
                                    <th>Sueldo quincenal</th>
                                    <th>Faltas</th>
                                    <th>Dia pagado no laborable</th>
                                    <th>Descuento del dia</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>${data.efectivo.toFixed(2)}</td>
                                    <td>${data.transferencia}</td>
                                    <td>${Math.round(data.dia * 15).toFixed(2)}</td>
                                    <td>{data.faltas}</td>
                                    <td>
                                        Dias: {data.extra} ---${data.extra * data.dia * 2}
                                    </td>
                                    <td>{(data.dia * 1.16 * data.faltas).toFixed(2)}</td>
                                </tr>
                                <tr className="fs-5">
                                    <td
                                        colSpan="5 "
                                        className="text-end border border-secondary bg-success table-light fw-bolder"
                                        style={{ backgroundColor: 'red' }}>
                                        TOTAL
                                    </td>

                                    <td className="text-end fw-bolder border border-secondary">
                                        ${Math.round(data.total).toFixed(2)}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="text-center mb-4">
                        <hr style={{ width: '50%', height: '5px', margin: '20px auto', color: 'black' }} />
                        <h5>Firma del empleado</h5>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default ComponentPrint;
